// 储能的路由
import EnergyLayout from '@/layout/index.vue'
import EnergyHome from '@/views/energy/home.vue'
import EnergyCollector from '@/views/energy/collector.vue'
import EnergyAlarm from '@/views/energy/alarm.vue'
import EnergyReport from '@/views/energy/report.vue'
import EnergyReal from '@/views/energy/real.vue'
import EnergyStation from '@/views/energy/station.vue'
import EnergyHistory from '@/views/energy/history.vue'
import EnergyRemote from '@/views/energy/remote.vue'

const router = {
  path: '/layout',
  name: 'energyLayout',
  component: EnergyLayout,
  redirect: '/home',
  children: [
    {
      path: '/energy/home',
      name: 'energy_home',
      meta: {
        showTab: true,
        name: 'energy_home mulshow',
        title: '储能 概况'
      },
      component: EnergyHome
    },
    // 采集器列表/设备列表
    {
      path: '/energy/collector',
      name: 'energy_collector',
      meta: {
        showTab: true,
        name: 'energy_collector mulshow',
        title: '储能 设备列表'
      },
      component: EnergyCollector
    },
    // 报警列表
    {
      path: '/energy/alarm',
      name: 'energy_alarm',
      meta: {
        showTab: true,
        name: 'energy_alarm mulshow',
        title: '储能 报警列表'
      },
      component: EnergyAlarm
    },
    // 报表下载
    {
      path: '/energy/report',
      name: 'energy_report',
      meta: {
        showTab: true,
        name: 'energy_report mulshow',
        title: '储能 报表下载'
      },
      component: EnergyReport
    },
    // 实时数据
    {
      path: '/energy/real',
      name: 'energy_real',
      meta: {
        showTab: true,
        name: 'energy_real mulshow',
        title: '储能 实时数据'
      },
      component: EnergyReal
    },
    // 电站设置
    {
      path: '/energy/station',
      name: 'energy_station',
      meta: {
        showTab: true,
        name: 'energy_station mulshow',
        title: '储能 电站设置'
      },
      component: EnergyStation
    },
    // 历史数据
    {
      path: '/energy/history',
      name: 'energy_history',
      meta: {
        showTab: true,
        name: 'energy_history mulshow',
        title: '储能 历史数据'
      },
      component: EnergyHistory
    },
    // 远程设置
    {
      path: '/energy/remote',
      name: 'energy_remote',
      meta: {
        showTab: true,
        name: 'energy_remote mulshow',
        title: '储能 远程设置'
      },
      component: EnergyRemote
    }
  ],

}

export default router
